module.exports = __webpack_public_path__ + "static/media/registered-model.27426c1d.svg";